import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { StateOptions } from '../../shared/const'

import styles from './style.module.scss'

const ALL_VALUES = StateOptions.map(option => option.value)

/**
 * Mehrfachauswahl der Bundeslaender, die fuer eine Unterstuetzer:in relevant
 * sind (Ziel-Bundeslaender, `targetStates`). Wird auf den oeffentlichen Formularen
 * Registrierung und Aktivierung genutzt.
 *
 * "Alle" ist keine eigene gespeicherte Auswahl, sondern schaltet alle
 * Bundeslaender auf einmal an oder aus. So bleibt der Wert kompatibel mit dem
 * Profil-Editor und dem Schueler:innen-Matching, die mit den konkreten
 * Bundeslaendern arbeiten.
 *
 * `label`, `hint` und `error` gibt es fuer den zweiten Einsatz: die
 * Bundeslaender der eigenen Junior Company Teilnahme (Anforderung #181) - dort
 * ist es eine andere Frage, mit eigener Beschriftung und Pflicht.
 */
export default function StatesField({ value = [], onChange, label, hint, error }) {
	const { t } = useTranslation()
	const labelText = label || t('states')
	const hintText = hint || t('relevantStatesHint')

	const allSelected = ALL_VALUES.every(state => value.includes(state))

	const toggle = state =>
		onChange(value.includes(state) ? value.filter(item => item !== state) : [...value, state])

	const toggleAll = () => onChange(allSelected ? [] : [...ALL_VALUES])

	return (
		<div className={styles.field}>
			<span className={styles.label}>
				{labelText}
				<span className={styles.info} tabIndex={0} aria-label={hintText}>
					i<span className={styles.tooltip}>{hintText}</span>
				</span>
			</span>

			<div className={styles.chips}>
				<button
					type="button"
					className={clsx(styles.chip, styles.allChip, allSelected && styles.chipOn)}
					onClick={toggleAll}
				>
					{t('all')}
				</button>
				{StateOptions.map(option => (
					<button
						key={option.value}
						type="button"
						className={clsx(styles.chip, value.includes(option.value) && styles.chipOn)}
						onClick={() => toggle(option.value)}
					>
						{option.label}
					</button>
				))}
			</div>
			{error && <span className={styles.error}>{error}</span>}
		</div>
	)
}
